<ul class="med-breadcrumb">
  <li class="med-breadcrumb__item">
    <a
      routerLink="/"
      class="med-breadcrumb__link"
    >
      <med-icon-home size="12"></med-icon-home>
    </a>
  </li>

  <li
    *ngFor="let breadcrumb of breadcrumbs$ | async"
    class="med-breadcrumb__item"
  >
    <a
      [routerLink]="breadcrumb.url"
      class="med-breadcrumb__link"
    >
      <ng-container *ngIf="labelTemplate; else defaultTemplate">
        <ng-container *ngTemplateOutlet="labelTemplate; context: { $implicit: breadcrumb.label }"></ng-container>
      </ng-container>

      <ng-template #defaultTemplate> {{ breadcrumb.label }} </ng-template>
    </a>
  </li>
</ul>
